import { values } from './enums'

const _enum = {
  Other: 0,
  ReportSubmission: 1,
  FineImposition: 2
}

export const workflowDefinitionType = {
  enumName: 'WorkflowDefinitionType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/workflowDefinitionType.js